import intl from "react-intl-universal";

const statusStyles = {
  processed: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400",
  pending: "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400",
  rejected: "bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-400",
};

export const BaasTransactionStatusBadge = ({ status, refunded = false, returned = false }) => {
  if (refunded) {
    return (
      <span className="inline-flex rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600 dark:bg-brand-dark-elevated dark:text-gray-400">
        {intl.get("baas.transactions.status.refunded")}
      </span>
    );
  }

  if (returned) {
    return (
      <span className="inline-flex rounded-full bg-orange-50 px-2.5 py-0.5 text-xs font-medium text-orange-700 dark:bg-orange-950/40 dark:text-orange-400">
        {intl.get("baas.transactions.status.returned")}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${statusStyles[status] ?? ""}`}
    >
      {intl.get(`baas.transactions.status.${status}`)}
    </span>
  );
};
